/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.outPlanMaster.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
